export const dashboardState: aboTheme.IState = {

  parent: 'app',
  name: "dashboard",
  url: "/dashboard?:newsall",
  params: {
    "newsall" : { dynamic: true } ,
  },
  component: 'dashboard',
  data: {
    permissions: {
        only: ['BACKOFFICE'],
        redirectTo: 'customerShifts'
    }
  }
};

export const newsItemBasicState: aboTheme.IState = {

  name: "dashboard.newsitem",
  url: "/newsitem/:id",
  params: {
    "id": null
  },
  modal: [],
  resolve: {
  },
  component: 'newsItemBasicComponent'
};


// WEBPACK FOOTER //
// ./src/app/modules/dashboard/dashboard.states.ts